import {useI18n} from 'i18n/I18nContext'
import {useInvoicesModals} from 'attendee/Invoices/InvoicesModalsProvider'
import {useAttendeeTransactions} from 'attendee/Invoices/Transactions/AttendeeTransactionsProvider'
import moment from 'moment'
import {Transaction} from 'organization/Invoices/Transactions/OrganizationTransactionsProvider'
import React from 'react'
import styled from 'styled-components'

export default function AttendeeTransactions() {
  const {t} = useI18n()
  const {transactions} = useAttendeeTransactions()
  const {setCreateInvoiceModalOpen, setCreateInvoiceSelectedTransaction} =
    useInvoicesModals()

  const createInvoice = (transaction: Transaction) => {
    setCreateInvoiceModalOpen(true)
    setCreateInvoiceSelectedTransaction(transaction)
  }

  const InvoiceButton = (props: {transaction: Transaction}) => {
    const {transaction} = props

    if (transaction.invoice) {
      return (
        <span>
          <i>
            {t('orgInvoiceTx.invoiceIssued').replace(
              '#{number}',
              String(transaction.invoice.number),
            )}
          </i>
        </span>
      )
    }

    return (
      <PrimaryButton
        onClick={() => {
          createInvoice(transaction)
        }}
      >
        {t('orgInvoiceTx.createBtn')}
      </PrimaryButton>
    )
  }

  return (
    <>
      <div className="attendant__wrapper mb-35">
        <table>
          <thead>
            <tr>
              <th>{t('orgInvoiceTx.thNumber')}</th>
              <th>{t('orgInvoiceTx.thDate')}</th>
              <th>{t('orgInvoiceTx.thAmount')}</th>
              <th>{t('orgInvoiceTx.thPurchase')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {transactions.length === 0 && (
              <tr>
                <td colSpan={5}>{t('orgInvoiceTx.empty')}</td>
              </tr>
            )}
            {transactions &&
              transactions.map((transaction, index) => {
                return (
                  <tr key={1}>
                    <td>
                      <div className="attendant__serial">
                        <span> {index + 1} </span>
                      </div>
                    </td>
                    <td>
                      <div className="attendant__date">
                        <span>
                          {moment
                            .unix(transaction.created)
                            .format('DD.MM.YYYY HH:mm')}{' '}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span> {(transaction.amount / 100).toFixed(2)} €</span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span> {transaction.description}</span>
                      </div>
                    </td>

                    <td>
                      <div>
                        <InvoiceButton transaction={transaction} />
                      </div>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    </>
  )
}
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`

export const SectionTitle = styled.h3`
  margin: 0;
`

export const PrimaryButton = styled.button`
  border: none;
  border-radius: 10px;
  padding: 10px 12px;
  background: linear-gradient(91deg, #f7426f 5.15%, #f87a58 99.88%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const CompanyName = styled.div`
  font-weight: 800;
  margin-bottom: 8px;
`

export const CompanyLine = styled.div`
  margin: 4px 0;
  color: #333;
`

export const CompanyCard = styled.div`
  border: 1px solid #eee;
  border-radius: 14px;
  padding: 14px;
  background: #fafafa;
`

export const CardActions = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
`

export const SecondaryButton = styled.button`
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  color: #111;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 3.5rem 0;
  font-size: 1.1rem;
  color: ${({theme}) => theme?.colors?.textSecondary || '#777'};
`
